



















































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'

import {
  IDistrict,
} from '@/graphql/district/interfaces/district'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import { GenerateLocaleDict } from '@/lib/Locale'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { District, Checklist, ChecklistItem, Info } from '../models/index'
import { HubEvents } from '@/amplify'
import { app } from "@/main"

 export async function duplicateDistrict(district: IDistrict, targetTenantId: string | undefined) {
    try {
      const { id: originalDistrictId, createdAt, updatedAt, tenantDistrictsId, ...clone } = district
      const tenant = targetTenantId || clone.tenant;
      const { id: clonedDistrictId } = await DataStore.save(
        new District({
          ...clone,
          tenant,
          name: {
            de: `${clone.name.de} (Duplikat)`,
          },
        }),
      )
      const checklistIds = []
      const [checklists, infos] = await Promise.all([
        DataStore.query(Checklist, p => p.districtID.eq(originalDistrictId)),
        DataStore.query(Info, p => p.districtID.eq(originalDistrictId)),
      ])

      await Promise.all(
        infos.map(async i => {
          const { id, createdAt, updatedAt, ...clone } = i
          await DataStore.save(
            new Info({
              ...clone,
              tenant,
              districtInfosId: clonedDistrictId,
              districtID: clonedDistrictId,
            })
          )
        }),
      )
      await Promise.all(
        checklists.map(async i => {
          const { id: originalChecklistId, createdAt, updatedAt, ...clone } = i
          const { id: clonedChecklistId } = await DataStore.save(
            new Checklist({
              ...clone,
              tenant,
              districtChecklistsId: clonedDistrictId,
              districtID: clonedDistrictId,
            })
          )
          checklistIds.push({ originalId: originalChecklistId, clonedId: clonedChecklistId })
        })
      )
      await Promise.all(
        checklistIds.map(async ({ originalId, clonedId }) => {
          await Promise.all(
            (await DataStore.query(ChecklistItem, p => p.checklistID.eq(originalId))).map(async i => {
              const { id, createdAt, updatedAt, ...clone } = i
              await DataStore.save(
                new ChecklistItem({
                  ...clone,
                  tenant,
                  checklistItemsId: clonedId,
                  checklistID: clonedId,
                })
              )
            })
          )
        })
      )
      mutateSnackbar(
        { text: String(`Bezirk dupliziert.`), color: `success` },
        app.$apollo
      )
    } catch(err) {
      console.error(err)
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        app.$apollo
      )
    }
  }

@Component<DistrictsView>({
  components: {
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('districts.title')
    }
  },
  apollo: {
    tenant,
  },
})
export default class DistrictsView extends Vue {

  districts = []
  districtsSubscription = null
  isLoading = true
  clone = null

  @Watch('tenant')
  async recreate() {
    this.subscribeToDataStore();
  }

  subscribeToDataStore() {
    if (!this.tenant) return;
    this.districtsSubscription?.unsubscribe()
    this.districtsSubscription = DataStore.observeQuery(
      District,
      p => p.tenant.eq(this.tenant.id),
    ).subscribe(({ items }) => {
      items.sort(function(a, b){
        if(a.name.de < b.name.de) { return -1; }
        if(a.name.de > b.name.de) { return 1; }
        return 0;
      })
      this.districts = items
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }
  created() {
    this.subscribeToDataStore();
  }
  destroyed() {
    this.districtsSubscription?.unsubscribe()
  }

  async duplicateDistrict = duplicateDistrict

  async editDistrict(name: string, district: IDistrict) {
    try {
      await DataStore.save(
        District.copyOf(
          await DataStore.query(District, district.id),
          updated => {
            updated.name =  GenerateLocaleDict({ de: name })
          }
        )
      )
      mutateSnackbar(
        { text: String(`Änderung gespeichert.`), color: `success` },
        this.$apollo
      )
      Hub.dispatch('ListEdit', {
        event: HubEvents.itemUpdate,
        data: {
          model: 'Checklist',
        }
      })
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }

  async deleteDistrict(district: IDistrict) {
    try {
      await DataStore.delete(District, item => item.id.eq(district.id))
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }

  async addDistrict(name: string) {
    try {
      await DataStore.save(
        new District({
          name: GenerateLocaleDict({ de: name }),
          tenant: this.tenant?.id
        })
      )
      mutateSnackbar(
        { text: String(`Bezirk erstellt.`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }
}
